export type ProductionCenterParametersType = {
  group_id?: string;
};

export enum ProductionCenterTypeEnum {
  PORTAINER = 'portainer',
}

type ProductionCenterType = {
  id: string;
  created_at: string;
  created_by: string;
  updated_at: string | null;
  updated_by: string | null;
  deleted_at: string | null;
  deleted_by: string | null;
  name: string;
  description: string | null;
  parameters: ProductionCenterParametersType | null;
  production_center_type: ProductionCenterTypeEnum;
};

type TProductionCenterForm = {
  name: string;
  production_center_type: ProductionCenterTypeEnum;
  description?: string;
  parameters?: {
    group_id?: string;
  } | null;
};

type ProductionCenterFilters = {
  idIn: string[];
  type: ProductionCenterType;
  updatedByIn: string[];
};

export type { ProductionCenterType, TProductionCenterForm, ProductionCenterFilters };
